import React from "react";
import AppLogo from "../../components/AppLogo";
import {
  InfoSvg,
  PremiumIntroDemoPng,
  PremiumIntroPng,
  StarSvg,
} from "../../components/Assets";
import SolidBlueBtn from "../../components/buttons/SolidBlueBtn";
import SmallBanner from "../../components/SmallBanner";
import TopBackPage from "../../components/TopPageBack";
import { APP_TYPES } from "../../constants/AppConstants";
import useHandleSaleLink from "../../hooks/useHandleSaleLink";

export default function PremiumIntro() {
  const { handleSaleLink } = useHandleSaleLink();
  
  return (
    <div className="flex flex-col">
      <TopBackPage
        style={{ background: "#111B48" }}
        isWhite={true}
      ></TopBackPage>
      <div
        className="flex flex-col text-white bg-darkblue px-7"
        style={{
          fontSize: "28px",
        }}
      >
        <span>스폰지R 프리미엄으로</span>
        <span>리뷰 관리 고민을</span>
        <span>덜어보세요!</span>
      </div>
      <div className="flex bg-darkblue">
        <img
          className="ml-auto"
          src={PremiumIntroPng}
          style={{ height: "190px" }}
        />
      </div>
      <div className="flex flex-col pt-8 pb-6 pl-5 bg-white text-appblue text-22">
        <b>오직 프리미엄에서만</b>
        <b>제공하는 기능!</b>
      </div>
      <IntroRow
        val={[
          "하나",
          "관심 리뷰 알림",
          [
            "사장님이 챙겨 보셔야 할 중요한 고객의 피드백이나 악성 리뷰만 골라 자동으로 분류하여 카카오 알림톡으로 보내드려요.",
          ],
        ]}
      />
      <IntroRow
        val={[
          "둘",
          "추천 댓글 및 자동 등록",
          [
            `각 리뷰에 맞는 최적의 댓글 초안을 대신 작성하여 추천 드리고 자동으로 등록까지 처리해 드려요.`,
          ],
        ]}
      />
      <DumpReview />
      <IntroRow
        val={[
          "셋",
          "댓글 자동 등록일 설정",
          [
            "리뷰가 달리고 2~3일 뒤 댓글을 달면 가게를 한번 더 노출 시킬 수 있어요.",
            "댓글이 자동 등록되는 시점을 설정해 보세요.",
          ],
        ]}
      />
      <IntroRow
        val={[
          "넷",
          "추가 댓글 설정",
          [
            "가게 홍보, 이벤트 등의 추가 내용을 설정하시면 모든 댓글에 일일이 붙여넣기 하지 않아도 홍보 효과를 높일 수 있어요!",
          ],
        ]}
      />
      <Dump2></Dump2>
      {/* <IntroRow2></IntroRow2> */}
      <div>
        <div className="mx-5 ">
          <SolidBlueBtn
            onClick={handleSaleLink}
            className={"w-full mb-2 h-[56px]"}
            style={{ padding: "7px 0" }}
          >
            <span className="flex flex-col">
              <span className="text-base text-white">프리미엄 가입하기</span>
              {/* <span className="text-sm " style={{ color: "#94DFFF" }}>
                최초 1회만 제공
              </span> */}
            </span>
          </SolidBlueBtn>
        </div>
      </div>
    </div>
  );
}

function IntroRow({ val }) {
  return (
    <div className="flex flex-col gap-3 px-5 bg-white py-7">
      <div className="flex items-center gap-2">
        <span className="bg-appblue px-2 py-0.5 rounded-full text-white text-xs h-[22px] mt-[2.5px]">
          {val[0]}
        </span>
        <b className="text-[18px]">{val[1]}</b>
      </div>
      <div className="flex flex-col">
        {val[2].map((x) => {
          return (
            <span key={x} className="text-[15px]">
              {x}
            </span>
          );
        })}
      </div>
    </div>
  );
}

function IntroRow2() {
  return (
    <div
      className="flex flex-col px-5 py-7"
      style={{
        background: "#F8F9FC",
      }}
    >
      <div className="flex gap-2">
        <span>
          <img src={InfoSvg} className="w-5 h-5 mt-0.5"></img>
        </span>
        <b className="text-[#111B48] mb-3">유의사항</b>
      </div>
      <div className="pl-2">
        <ul className="list-disc pl-4 text-[#767A85]">
          <li>무료 체험은 최초 1회만 가능합니다.</li>
          <li>
            한 달간의 무료 체험 기간 이후 유료 서비스로 자동 전환되어 출금이
            진행됩니다. 출금을 원치 않으시면 서비스 해지 신청을 해주시기를
            바랍니다.
          </li>
        </ul>
      </div>
    </div>
  );
}

const DumpReview = () => {
  return (
    <div className="px-5 mb-7">
      <div className="w-full px-5 py-6 lite-border rounded-3xl">
        <div className="flex justify-between mb-4">
          <span className="text-xs text-datesub">2023.08.08</span>
          <div
            className="px-2 py-0.5 rounded-full text-xs"
            style={{ backgroundColor: "#F6F3FF", color: "#683DE1" }}
          >
            <b>등록 대기</b>
          </div>
        </div>
        <div className="flex items-center justify-between mb-4">
          <div className="flex gap-2.5 items-center">
            <AppLogo appName={APP_TYPES.Beamin.name} isByName={true} />
          </div>
          <div className="flex items-center gap-1">
            <img src={StarSvg} className="w-3.5 h-3.5"></img>
            <b className="text-lg">4.5점</b>
          </div>
        </div>
        <div className="mb-8">
          <b className="text-darkblue">[3548] 짜장면이 맛있는 집 - 홍대점</b>
        </div>
        <div className="mb-4">
          <span className="text-darkblue">
            문자로 배달 알림이 오지 않아서 짜장면이 다 불었어요 ㅠㅜ;;;
          </span>
        </div>
        <div className="flex pb-[14px] ">
          <span className="px-3 py-[7.5px] bg-[#F5F7FF] text-[#3451D7] rounded-md">
            짜장면
          </span>
        </div>
        <div
          className="p-2.5"
          style={{
            border: "2px dashed #3451D7",
            borderRadius: "22px",
            width: "calc(100% + 20px)",
            marginLeft: "-10px",
          }}
        >
          <div
            className="flex flex-col gap-5 p-4 bg-fa rounded-xl"
            style={{ borderRadius: "12px" }}
          >
            <div className="flex flex-col gap-5 bg-fa">
              <div className="flex items-center justify-between gap-1">
                <b className="text-base text-darkblue">추천 댓글</b>
              </div>

              <SmallBanner>
                ✅ 등록 요청이 접수되어 1시간 이내로 <br /> 사장님 사이트에
                등록될 예정이에요.
              </SmallBanner>
              <span className="flex flex-col">
                <span className="text-darkblue">안녕하세요 마츠모토준님.</span>
                <span className="text-darkblue">
                  짜장면이 맛있는 집을 이용해주셔서 감사합니다.
                </span>
                <span className="text-darkblue">
                  알림을 보내드리지 않아 정말 죄송합니다. 다음에는 문자로 배달
                </span>
                <span className="text-darkblue">
                  도착 알림을 꼭 보내드리고 앞으로 더 맛있는 음식으로
                </span>
                <span className="text-darkblue">
                  보답하도록 노력하겠습니다.
                </span>
                <span className="text-darkblue">감사합니다!</span>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const Dump2 = () => {
  return (
    <div className="px-5 mb-7">
      <img src={PremiumIntroDemoPng}></img>
    </div>
  );
  // return <div className="px-5 mb-7">
  //   <div className="w-full px-5 py-6 lite-border rounded-3xl">
  //     <img src={PremiumIntroDemoPng}></img>
  //   </div>
  // </div>;
};
